export default function (xAxisG, text, position = {}) {
  const hoverText = xAxisG.append('g').attr('visibility', 'hidden');

  if (position.x || position.y) {
    hoverText.attr(
      'transform',
      'translate(' + (position.x ? position.x : 0) + ', ' + (position.y ? position.y : 0) + ')',
    );
  }

  const hoverBgRect = hoverText.append('rect').attr('fill', 'white').attr('x', '-5');

  const textBoxWidth = 400;

  const xAxisGText = hoverText
    .append('text')
    .attr('fill', 'currentColor')
    .attr('text-anchor', 'start')
    .attr('width', textBoxWidth)
    .attr('dominant-baseline', 'baseline')
    .text(text);

  const textLength = xAxisGText.node().getComputedTextLength();
  const noOfLines = Math.ceil(textLength / textBoxWidth);
  const textEls = text.split(' ');

  const elementsInLine = Math.ceil(textEls.length / noOfLines);

  const lines = [];
  for (let i = 0; i < noOfLines; i++) {
    lines.push(textEls.slice(i * elementsInLine, (i + 1) * elementsInLine).join(' '));
  }

  xAxisGText.text('');

  lines.forEach((line) => {
    xAxisGText.append('tspan').attr('x', '0').attr('dy', '1.2em').text(line);
  });

  const textBBox = hoverText.node().getBBox();

  hoverBgRect.attr('height', textBBox.height + 10).attr('width', textBBox.width + 10);

  return hoverText;
}
